<template>
  <div class="row">
    <div class="col-12">
      <div class="row d-flex justify-content-center">
        <div class="col-10 mt-2">
          <el-card
            shadow="always"
            class="p-0"
            style="border-radius: 10px"
            v-loading="loading"
          >
            <div class="d-flex justify-content-center pb-4">
              <div
                v-for="stepOption in steps"
                :key="stepOption.id"
                class="text-center"
                style="width: 200px"
              >
                <div
                  class="status-requirements"
                  style="position: relative"
                  :class="[
                    {
                      'pending-action':
                        stepOption.id >= step && !clientForm.sent_at,
                    },
                    {
                      approved: stepOption.id < step || clientForm.sent_at,
                    },
                  ]"
                >
                  <i
                    class="fa fa-check-circle"
                    v-if="stepOption.id < step || clientForm.sent_at"
                    style="
                      font-size: 65px;
                      position: absolute;
                      left: -2px;
                      top: -2px;
                    "
                  ></i>
                </div>
                <div
                  class="mt-2 status-requirements-text"
                  :class="[
                    {
                      'pending-action':
                        stepOption.id >= step && !clientForm.sent_at,
                    },
                    {
                      approved: stepOption.id < step || clientForm.sent_at,
                    },
                  ]"
                >
                  {{ stepOption.name }}
                </div>
              </div>
            </div>
            <div class="row pb-4" v-if="step == 1">
              <div class="col-12 col-md-6">
                <div class="text-navy text-uppercase mb-2 font-weight-bold">
                  Producer Info
                </div>
                <div class="row" v-if="!clientForm.lead_id">
                  <div class="col-6 my-2">
                    <label
                      class="font-weight-bold"
                      :class="'full_name' in errors && 'text-danger'"
                      >Signer Full Name</label
                    >
                    <el-input v-model="clientForm.full_name"></el-input>
                  </div>
                  <div class="col-6 my-2">
                    <label
                      class="font-weight-bold"
                      :class="'email' in errors && 'text-danger'"
                      >Signer Email</label
                    >
                    <el-input v-model="clientForm.email"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'name' in errors && 'text-danger'"
                      >Client Name</label
                    >
                    <el-input v-model="clientForm.name"></el-input>
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'time_known' in errors && 'text-danger'"
                      >How long has this client been known to the Agency?</label
                    >
                    <el-input v-model="clientForm.time_known"></el-input>
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'history' in errors && 'text-danger'"
                      >Please provide a brief history of client/agency
                      relationship</label
                    >
                    <el-input
                      type="textarea"
                      :rows="clientForm.lead_id ? 6 : 3"
                      v-model="clientForm.history"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="text-navy text-uppercase mb-2 font-weight-bold">
                  Trading Details
                </div>
                <div class="row">
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'volume_annually' in errors && 'text-danger'"
                      >Volume of livestock transacted annually</label
                    >
                    <el-input v-model="clientForm.volume_annually"></el-input>
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'properties' in errors && 'text-danger'"
                      >Property Type</label
                    >
                    <el-select
                      v-model="clientForm.properties"
                      class="w-100"
                      multiple
                    >
                      <el-option
                        v-for="(item, index) in properties"
                        :key="index"
                        :label="item"
                        :value="item"
                        >{{ item }}</el-option
                      ></el-select
                    >
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'production_systems' in errors && 'text-danger'"
                      >Production Systems</label
                    >
                    <el-select
                      v-model="clientForm.production_systems"
                      class="w-100"
                      multiple
                    >
                      <el-option
                        v-for="(item, index) in production_systems"
                        :key="index"
                        :label="item"
                        :value="item"
                        >{{ item }}</el-option
                      ></el-select
                    >
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="font-weight-bold"
                      :class="'trading_plan' in errors && 'text-danger'"
                      >Trading Plan</label
                    >
                    <el-input
                      type="textarea"
                      rows="3"
                      v-model="clientForm.trading_plan"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-4" v-if="step == 2">
              <div class="col-12 text-navy pl-4 py-2">
                Assessment from 1 to 10 (1 being not acceptable) please rate the
                following
              </div>
              <div class="col-4 pl-4 py-2 font-weight-bold"></div>
              <div class="col-7 h-100 d-flex justify-content-between mb-4">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <span
                    class="checkmark-radio text-center"
                    style="border-color: #fff"
                    >{{ index }}</span
                  >
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'yards' in errors ? 'text-danger' : 'text-navy'"
              >
                Yards
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.yards"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'fences' in errors ? 'text-danger' : 'text-navy'"
              >
                Fences
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.fences"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'water' in errors ? 'text-danger' : 'text-navy'"
              >
                Water
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.water"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'shade' in errors ? 'text-danger' : 'text-navy'"
              >
                Shade
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.shade"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div class="col-12 text-navy pl-4 py-2">
                Assessment from 1 to 10 (1 being not acceptable) please rate the
                livestock husbandry practices in relation to
              </div>
              <div class="col-4 pl-4 py-2 font-weight-bold"></div>
              <div class="col-7 h-100 d-flex justify-content-between mb-4">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <span
                    class="checkmark-radio text-center"
                    style="border-color: #fff"
                    >{{ index }}</span
                  >
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'handling' in errors ? 'text-danger' : 'text-navy'"
              >
                Handling
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.handling"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'treating' in errors ? 'text-danger' : 'text-navy'"
              >
                Treating sick animals
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.treating"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div
                class="col-4 pl-4 py-2 font-weight-bold"
                :class="'mustering' in errors ? 'text-danger' : 'text-navy'"
              >
                Mustering
              </div>
              <div class="col-7 h-100 d-flex justify-content-between">
                <label
                  v-for="index in 10"
                  :key="index"
                  class="checkmark-radio-container"
                >
                  <input
                    type="radio"
                    v-model="clientForm.mustering"
                    :value="index"
                  />
                  <span class="checkmark-radio"></span>
                </label>
              </div>
              <div class="col-12 pl-4 py-2 mt-3">
                To be the best of your knowledge does this producers comply with
                the Animal Care Protection Act. (<a
                  href="https://animalwelfarestandards.net.au/"
                  target="_blank"
                  >https://animalwelfarestandards.net.au/</a
                >)
                <div class="d-flex flex-row mt-2">
                  <div
                    class="d-flex justify-content-between d-inline-block"
                    :class="
                      'is_animal_care_protected' in errors && 'text-danger'
                    "
                  >
                    Yes
                    <label class="checkmark-radio-container ml-1">
                      <input
                        type="radio"
                        v-model="clientForm.is_animal_care_protected"
                        :value="true"
                      />

                      <span class="checkmark-radio"></span>
                    </label>
                  </div>
                  <div
                    class="d-flex justify-content-between d-inline-block pl-5"
                    :class="
                      'is_animal_care_protected' in errors && 'text-danger'
                    "
                  >
                    No
                    <label class="checkmark-radio-container ml-1">
                      <input
                        type="radio"
                        v-model="clientForm.is_animal_care_protected"
                        :value="false"
                      />

                      <span class="checkmark-radio"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pb-4" v-if="step == 3">
              <div class="col-12 text-center my-4">
                <h2>New Client Form Completed</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <el-button
                  class="btn-secondary"
                  @click="step--"
                  v-if="step > 1"
                >
                  Back
                </el-button>
                <el-button
                  class="btn-secondary"
                  @click="step++"
                  v-if="step == 1 || (step < 3 && clientForm.sent_at)"
                >
                  Next
                </el-button>

                <el-button-group
                  v-if="
                    !clientForm.sent_at &&
                    (!clientForm.docusign_envelope ||
                      !clientForm.docusign_envelope.embedded_url)
                  "
                >
                  <el-button
                    class="btn-primary"
                    @click="onSubmit(false)"
                    style="margin-top: -1px"
                  >
                    {{ step == 1 ? "Save Progress" : "Send" }}
                  </el-button>
                  <el-dropdown v-if="step > 1 && !user">
                    <el-button
                      class="btn-primary"
                      style="
                        border-left: 1px #fff solid !important;
                        padding-left: 10px;
                        padding-right: 10px;
                        margin-top: -1px;
                      "
                    >
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu
                        class="save-status-dropdown"
                        slot="dropdown"
                      >
                        <el-dropdown-item @click.native="onSubmit(true)">
                          <span class="d-flex align-items-center">
                            Send & sign
                          </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </el-button-group>

                <el-button
                  class="btn-primary"
                  v-if="
                    clientForm.docusign_envelope &&
                    clientForm.docusign_envelope.status != 'completed' &&
                    clientForm.docusign_envelope.embedded_url &&
                    !user
                  "
                  @click="openUrl"
                >
                  Sign
                </el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    initial_client_form: {
      type: Object,
    },
    user: {
      type: (Object, String),
    },
    signed_url: {
      type: String,
      required: true,
    },
    signed_envelope_url: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      clientForm: this.initial_client_form,
      properties: ["Owned", "Leased", "Agisted"],
      production_systems: [
        "Feedlot",
        "Supplementary fed",
        "Improved pasture/fodder crop",
        "Native pasture",
      ],
      step: 1,
      steps: [
        { id: 1, name: "Producer Details" },
        { id: 2, name: "Animal Welfare Declaration" },
      ],
      errors: [],
      loading: false,
    };
  },
  mounted() {
    this.step = this.initial_client_form.sent_at ? 3 : 1;
  },
  methods: {
    openUrl() {
      this.loading = true;
      axios
        .get(this.signed_envelope_url)
        .then((result) => {
          this.clientForm = result.data;
          if (this.clientForm.docusign_envelope) {
            window.location.href =
              this.clientForm.docusign_envelope.embedded_url;
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "Some fields are required",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    onSubmit(sign = false) {
      this.loading = true;
      this.errors = [];
      this.clientForm.step = this.step;
      this.clientForm.sign = sign;
      axios
        .put(this.signed_url, this.clientForm)
        .then((result) => {
          this.$message.success(this.step == 1 ? "Saved" : "Sent");
          this.clientForm = result.data;
          if (this.clientForm.docusign_envelope) {
            window.location.href =
              this.clientForm.docusign_envelope.embedded_url;
            this.step++;
          } else if (this.clientForm.sent_at) {
            this.step++;
          }
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message({
            type: "error",
            message: "Some fields are required",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
  },
};
</script>
